// firebaseConfig.js
export const firebaseConfig = {
  apiKey: "AIzaSyAkktSHQGFdve8o0G3lLC11UdWuxb9YIog",
  authDomain: "cfranze-ebrunius-edsr-puta.firebaseapp.com",
  projectId: "cfranze-ebrunius-edsr-puta",
  storageBucket: "cfranze-ebrunius-edsr-puta.firebasestorage.app",
  messagingSenderId: "39997752342",
  appId: "1:39997752342:web:80fd057ddc17f7725be137"
};